import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  beginPlatformLogin,
  configurePlatformAuth,
  establishPlatformSession,
  platformPasskeyEnrollmentUrl,
} from '../../lib/platform-auth';

export function PlatformLoginPage() {
  const [error, setError] = useState<string | null>(null);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    configurePlatformAuth().then(() => setReady(true)).catch((reason: unknown) =>
      setError(reason instanceof Error ? reason.message : 'Platform sign-in is unavailable.'),
    );
  }, []);
  return (
    <main className="mx-auto max-w-md px-6 py-20">
      <h1 className="mb-3 font-serif text-3xl">Platform sign-in</h1>
      <p className="mb-6 text-neutral-600">Sign in with your Witness platform account.</p>
      {error && <p role="alert" className="mb-4 text-red-800">{error}</p>}
      <button
        disabled={!ready}
        onClick={() => beginPlatformLogin().catch((reason: unknown) => setError(reason instanceof Error ? reason.message : 'Could not start sign-in.'))}
        className="rounded bg-neutral-900 px-4 py-2 text-white disabled:opacity-50"
      >
        Continue to sign in
      </button>
    </main>
  );
}

export function PlatformCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    configurePlatformAuth()
      .then(establishPlatformSession)
      .then(() => setReady(true))
      .catch((reason: unknown) => setError(reason instanceof Error ? reason.message : 'Could not establish platform session.'));
  }, []);
  if (error) return <main className="mx-auto max-w-md px-6 py-20">
    <p role="alert" className="mb-4 text-red-800">{error}</p>
    <Link className="underline" to="/platform/login">Try signing in again or use a different account</Link>
  </main>;
  if (!ready) return <main className="mx-auto max-w-md px-6 py-20">Completing sign-in…</main>;
  return (
    <main className="mx-auto max-w-md px-6 py-20">
      <h1 className="mb-3 font-serif text-3xl">You’re signed in</h1>
      <p className="mb-6 text-neutral-600">If this device does not yet have a passkey, enroll one now.</p>
      <div className="flex gap-3">
        <a className="rounded bg-neutral-900 px-4 py-2 text-white" href={platformPasskeyEnrollmentUrl()}>
          Enroll passkey
        </a>
        <button className="rounded border border-neutral-300 px-4 py-2" onClick={() => navigate('/platform/tenants')}>
          Continue
        </button>
      </div>
    </main>
  );
}
